import React from 'react'
import { Trans, useTranslation } from '@mc/i18n'
import { PlansTier } from '@mc/plans-ui'
import { INTRO_PRICING_I18N_NAMESPACE } from '../../i18n'

export const PricingCell = ({
  tier: { displayMonthlyPrice, displayMonthlyPriceWithDiscount, product },
}: {
  tier: PlansTier
}) => {
  const { t } = useTranslation(INTRO_PRICING_I18N_NAMESPACE)
  const hasDiscountPrice = !!displayMonthlyPriceWithDiscount
  const discount = Math.round(product?.coupon?.percentage || 0)

  if (hasDiscountPrice) {
    return (
      <div className='d-flex flex-column'>
        <span
          className='mc-text--success mc-text--bold mc-text-x-small mc-mb-1'
          aria-label={t('plans.features.pricing.cell.discountLabel', {
            discount,
          })}
        >
          <Trans
            i18nKey='plans.features.pricing.cell.discountShow'
            ns={INTRO_PRICING_I18N_NAMESPACE}
            values={{ discount }}
          >
            <br />
          </Trans>
        </span>
        <span>
          <span
            aria-label={t('plans.features.pricing.cell.previous', {
              previousPrice: displayMonthlyPrice,
            })}
            className='mc-mx-1 mc-text-color--gray-500 mc-text--strike'
          >
            {displayMonthlyPrice}
          </span>
          <span
            aria-label={t('plans.features.pricing.cell.current', {
              price: displayMonthlyPriceWithDiscount,
            })}
            className='mc-text--bold'
          >
            {displayMonthlyPriceWithDiscount}
          </span>
        </span>
      </div>
    )
  }

  return (
    <span
      aria-label={t('plans.features.pricing.cell.price', {
        price: displayMonthlyPrice,
      })}
    >
      {displayMonthlyPrice}
    </span>
  )
}
